import React from 'react';
import { Link } from 'react-router-dom';
import { LoginHeader } from '../Common/LoginHeader';
import { Footer } from '../Common';
import { connect } from 'react-redux';
import { buyerLogin } from '../../Action/login';
import { withRouter } from 'react-router-dom';
import SimpleReactValidator from 'simple-react-validator';
import { GoogleLoginItem } from './GoogleLoginItem';
import { FacebookLoginItem } from './FacebookLoginItem';
import { LineLogin } from './LineLogin';
import {FacebookFirebaseLogin, GoogleFirebaseLogin} from "../components";
import {withTranslation} from "react-i18next";
class BuyerLogin extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            _id: false,
            buyerEmail: '',
            buyerPassword: '',
            user_type: 1,
            errors: [],
        };
        SimpleReactValidator.addLocale('klingon', {
            integer: `${this.props.t('VERIFY_MSG.INTEGER')}`,
            max: `:attribute :max ${this.props.t('VERIFY_MSG.MAX')}`,
            required: ` :attribute ${this.props.t('VERIFY_MSG.REQUIRED')}`,
            min: `:attribute :min ${this.props.t('VERIFY_MSG.MIN')}`,
        });
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            locale: 'klingon',
        })
    }
    componentDidMount() {
        window.scrollTo(0, 0);
        window.localStorage.removeItem('info');
        window.localStorage.removeItem('pro_pic');
        localStorage.clear();
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.errors) {
            if(nextProps.errors.errors === 'WRONG_CRED'){
                nextProps.errors.errors = this.props.t('LOGIN_PAGE.WRONG_CRED');
            }
            this.setState({ errors: nextProps.errors })
        }
    }
    updateField(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }

    handleSocialLogin = (user) => {
        console.log('asd')
        console.log(user)
    }

    handleSocialLoginFailure = (err) => {
        console.log('asd')
        console.error(err)
    }

    handleSubmit(e) {
        e.preventDefault();
        if (this.validator.allValid()) {
            let data = {
                email: this.state.buyerEmail,
                password: this.state.buyerPassword,
            }
            console.log(data);
            this.props.buyerLogin(data, this.props.history);
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        const { errors } = this.state.errors;
        if (isMobile) {
            return (
                <div>
                    <div className="container-fluid">
                        <div className="col-md-12" >
                            <div className="">
                                <LoginHeader />
                            </div>
                        </div>
                        <div className="col-md-12 tr_blank_medium mt-5 pt-2"> </div>
                        <div className="row ">
                            <div className="col-md-2">
                            </div>
                            <div className="col-md-4 ">
                                <div className="big_text" style={{ paddingBottom: '0px' }} ><b>{this.props.t('LOGIN_PAGE.LOGIN_TITLE_BUYER')}</b></div>
                                <div className="login_inputs form-group" style={{ padding: '20px' }}>
                                    <form onSubmit={this.handleSubmit.bind(this)}>
                                        <span className="mb-2" style={{ color: "red" }} >{errors}</span>
                                        <div>
                                            <div className="name_text"><b>{this.props.t('LOGIN_PAGE.MAIL_ADDRESS') }</b>
                                            </div>
                                        </div>
                                        <div>
                                            <div>

                                                <input type="email" className="user_id_box form-control" placeholder={this.props.t('LOGIN_PAGE.MAIL_ADDRESS_PLACE')} id="email" value={this.state.buyerEmail} onChange={this.updateField.bind(this, "buyerEmail")} />
                                                {this.validator.message(this.props.t('LOGIN_PAGE.MAIL_ADDRESS'), this.state.buyerEmail, 'required')}
                                            </div>
                                        </div>
                                        <div><div>&nbsp;</div></div>
                                        <div>
                                            <div className="name_text"><b>{this.props.t('LOGIN_PAGE.PASSWORD')}</b>
                                            </div>
                                        </div>
                                        <div>
                                            <div>
                                                <input type="password" className="user_id_box form-control" placeholder={this.props.t('LOGIN_PAGE.PASSWORD_PLACE')} id="password1" value={this.state.buyerPassword} onChange={this.updateField.bind(this, "buyerPassword")} />
                                                {this.validator.message(this.props.t('LOGIN_PAGE.PASSWORD'), this.state.buyerPassword, 'required')}
                                            </div>
                                        </div>
                                        <div><div>&nbsp;</div></div>
                                        <div>
                                            <div className="remember_text"><input type="checkbox" />&nbsp;&nbsp;{this.props.t('LOGIN_PAGE.SAVE_LOGIN_INFO')}</div>
                                        </div>
                                        <div><div>&nbsp;</div></div>
                                        <div>
                                            <div className="input_name">
                                                <button type="submit" className="btn  btn-lg button_size" style={{ backgroundColor: "#7ea9e6", borderColor: "#6290d1", color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} >{this.props.t('LOGIN_PAGE.LOGIN_BUTTON')}</button>
                                            </div>
                                        </div>
                                        <div><div>&nbsp;</div></div>
                                        <div><div className="input_name remember_text">{this.props.t('LOGIN_PAGE.FORGOT_PASSWORD')}<Link className="blue_text" to={"/password-reset"}>{this.props.t('LOGIN_PAGE.ONCLICK_ACTION')}</Link> </div></div>
                                        <div><div className="input_name remember_text">{this.props.t('LOGIN_PAGE.NON_REGISTERED')}<Link className="blue_text" to={"/buyer-registration-step-1"}>{this.props.t('LOGIN_PAGE.ONCLICK_ACTION')}</Link> </div></div>
                                        <br />
                                        <div><div className="input_name remember_text">{this.props.t('LOGIN_PAGE.SELLER_LOGIN')}<Link className="blue_text" to={"/login/seller"}>{this.props.t('LOGIN_PAGE.ONCLICK_ACTION')}</Link> </div></div>
                                    </form>
                                </div>
                            </div>

                            <div className="col-md-4 " >
                                <div className="big_text">&nbsp;</div>
                                <div className="login_inputs form-group" style={{ height: "300px" }}>
                                    {/* <div className="tr_blank">
                                        <div>&nbsp;</div>
                                    </div> */}
                                    {/*<GoogleLoginItem id={this.state.user_type} />*/}
                                    <GoogleFirebaseLogin id={this.state.user_type} />
                                    <br />
                                    <br />
                                    {/*<FacebookLoginItem id={this.state.user_type} />*/}
                                    <FacebookFirebaseLogin id={this.state.user_type} />

                                    <br />
                                    <br />
                                    <LineLogin id={this.state.user_type}/>
                                    {/* <img alt="" src={require("../../assets/images/Logo-LINE.png")} height="50px" width='100%' /> */}
                                </div>
                            </div>
                            <div className="col-md-2">
                            </div>
                        </div>
                    </div>
                    <div className=" mt-5">
                        <Footer />
                    </div>
                </div>
            );
        }
        else if (isDesktop) {
            return (
                <div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12" >
                                <div className="">
                                    <LoginHeader />
                                </div>
                            </div>
                            <div className="col-md-12 tr_blank_medium mt-5 pt-4"> </div>
                            {/* <div className="col-md-12"> */}
                            <div className="row mt-5">
                                <div className="col-md-2">

                                </div>
                                <div className="col-md-4 mt-5">
                                    <div className="big_text"><b>{this.props.t('LOGIN_PAGE.LOGIN_TITLE_BUYER')}</b></div>
                                    <div className="login_inputs form-group pl-5">
                                        <form onSubmit={this.handleSubmit.bind(this)}>
                                            <span className="mb-2" style={{ color: "red" }} >{errors}</span>
                                            <div>
                                                <div className="name_text"><b>{this.props.t('LOGIN_PAGE.MAIL_ADDRESS') } </b>
                                                </div>
                                            </div>
                                            <div>
                                                <div>

                                                    <input type="email" className="user_id_box form-control" placeholder={this.props.t('LOGIN_PAGE.MAIL_ADDRESS_PLACE')} id="email" value={this.state.buyerEmail} onChange={this.updateField.bind(this, "buyerEmail")} />
                                                    {this.validator.message(this.props.t('LOGIN_PAGE.MAIL_ADDRESS'), this.state.buyerEmail, 'required')}
                                                </div>
                                            </div>
                                            <div><div>&nbsp;</div></div>
                                            <div>
                                                <div className="name_text"><b>{this.props.t('LOGIN_PAGE.PASSWORD')}</b>
                                                </div>
                                            </div>
                                            <div>
                                                <div>
                                                    <input type="password" className="user_id_box form-control" placeholder={this.props.t('LOGIN_PAGE.PASSWORD_PLACE')} id="password1" value={this.state.buyerPassword} onChange={this.updateField.bind(this, "buyerPassword")} />
                                                    {this.validator.message(this.props.t('LOGIN_PAGE.PASSWORD'), this.state.buyerPassword, 'required')}
                                                </div>
                                            </div>
                                            <div><div>&nbsp;</div></div>
                                            <div>
                                                <div className="remember_text"><input type="checkbox" />&nbsp;&nbsp;{this.props.t('LOGIN_PAGE.SAVE_LOGIN_INFO')}</div>
                                            </div>
                                            <div><div>&nbsp;</div></div>
                                            <div>
                                                <div className="input_name">
                                                    <button type="submit" className="btn  btn-lg button_size" style={{ backgroundColor: "#7ea9e6", borderColor: "#6290d1", color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} >{this.props.t('LOGIN_PAGE.LOGIN_BUTTON')}</button>
                                                </div>
                                            </div>
                                            <div><div>&nbsp;</div></div>
                                            <div><div className="input_name remember_text">{this.props.t('LOGIN_PAGE.FORGOT_PASSWORD')}<Link className="blue_text" to={"/password-reset"}>{this.props.t('LOGIN_PAGE.ONCLICK_ACTION')}</Link> </div></div>
                                            <div><div className="input_name remember_text">{this.props.t('LOGIN_PAGE.NON_REGISTERED')}<Link className="blue_text" to={"/buyer-registration-step-1"}>{this.props.t('LOGIN_PAGE.ONCLICK_ACTION')}</Link> </div></div>
                                            <br />
                                            <div><div className="input_name remember_text">{this.props.t('LOGIN_PAGE.SELLER_LOGIN')}<Link className="blue_text" to={"/login/seller"}>{this.props.t('LOGIN_PAGE.ONCLICK_ACTION')}</Link> </div></div>
                                        </form>
                                    </div>
                                </div>

                                <div className="col-md-4 mt-5">
                                    <div className="big_text">&nbsp;</div>
                                    <div className="login_inputs form-group">
                                        <div className="tr_blank" style={{ height: '25px' }}>
                                            {/* <div>&nbsp;</div> */}
                                        </div>
                                        <div className="tr_blank">
                                            {/* <div>&nbsp;</div> */}
                                        </div>
                                        {/*<GoogleLoginItem id={this.state.user_type} />*/}
                                        <GoogleFirebaseLogin id={this.state.user_type} />
                                        <br />
                                        <br />
                                        {/*<FacebookLoginItem id={this.state.user_type} />*/}
                                        <FacebookFirebaseLogin id={this.state.user_type} />
                                        <br />
                                        <br />
                                        <LineLogin />
                                        {/* <img alt="" src={require("../../assets/images/Logo-LINE.png")} height="50px" width='100%' /> */}
                                    </div>
                                </div>
                                <div className="col-md-2">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className=" mt-5">
                        <Footer />
                    </div>
                </div>
            );
        }
    }
}

const mapStateToProps = (state) => ({
    buyerLogin: state.buyerLogin,
    errors: state.errors,
});

BuyerLogin = connect(mapStateToProps, { buyerLogin })(withRouter(BuyerLogin));

export default withTranslation('buyer')(BuyerLogin);
